import { Trans } from "@lingui/react/macro";
import { motion } from "motion/react";

import { BrandIcon } from "@/components/ui/brand-icon";
import { Copyright } from "@/components/ui/copyright";

export function Footer() {
  return (
    <motion.footer
      id="footer"
      className="p-4 pb-8 will-change-[opacity] md:p-8 md:pb-12"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45 }}
    >
      <div className="flex flex-col items-center gap-6 text-center">
        <BrandIcon variant="logo" className="size-10" />

        <div className="space-y-2">
          <h2 className="text-lg font-bold tracking-tight">Huntr CV</h2>
          <p className="max-w-md text-sm leading-relaxed text-muted-foreground">
            <Trans>
              A free resume builder for blue-collar workers and professionals. Create, download, and share your CV —
              powered by Huntr.
            </Trans>
          </p>
        </div>

        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <a
            href="https://huntr.app"
            target="_blank"
            rel="noopener"
            className="transition-colors hover:text-foreground"
          >
            Huntr
          </a>
          <span>·</span>
          <a
            href="https://workforce.huntr.app"
            target="_blank"
            rel="noopener"
            className="transition-colors hover:text-foreground"
          >
            <Trans>Apply for Jobs</Trans>
          </a>
        </div>

        <Copyright />
      </div>
    </motion.footer>
  );
}
